import React, { useState, useEffect } from 'react';
import { login } from '../api';
import logo from '../assets/new_logo_consultoria.png';

export default function Login({ onLogin, onClose }) {
  const [loginVal, setLoginVal] = useState('');
  const [senha, setSenha] = useState('');
  const [err, setErr] = useState('');
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    setTimeout(() => setVisible(true), 10);
    return () => { document.body.style.overflow = ''; };
  }, []);

  const close = () => {
    setVisible(false);
    setTimeout(() => onClose && onClose(), 300);
  };

  const submit = async e => {
    e.preventDefault();
    try {
      const token = await login(loginVal, senha);
      onLogin(token);
    } catch (ex) {
      setErr(ex);
    }
  };

  return (
    <>
      <div className={`modal-backdrop-custom ${visible ? 'show' : ''}`} onClick={close}></div>

      <div className={`modal-custom ${visible ? 'show' : ''}`} tabIndex="-1" role="dialog" aria-modal="true">
        <div className="modal-dialog" style={{
              background: "white",
              padding: "20px",
              borderRadius: "15px"
          }}>
          <div className="modal-content">
            <form onSubmit={submit}>
              <div className="modal-header">
                <img src={logo} alt="Reconect" style={{ maxWidth: "100%" }} />
              </div>
              <div className="modal-body">
                <div className="mb-2">
                  <input className="form-control" placeholder="login" value={loginVal} onChange={e=>setLoginVal(e.target.value)} />
                </div>
                <div className="mb-2">
                  <input type="password" className="form-control" placeholder="senha" value={senha} onChange={e=>setSenha(e.target.value)} />
                </div>
                {err && <div className="alert alert-danger" style={{ textAlign: "center" }}>{String(err.message || err)}</div>}
              </div>
              <div className="modal-footer justify-content-between">
                <button type="button" className="btn btn-secondary" onClick={close}>Fechar</button>
                <button type="submit" className="btn btn-primary">Entrar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
